module.exports = __webpack_public_path__ + "img/bg-masthead.1c14d92e.jpg";